import { useApiDelete } from '@sierralabs/core-ui';
export function useDeleteEntity(id) {
    const { data, isLoading, error, del } = useApiDelete(`entities/${id}`);
    return {
        deletedEntity: data,
        deletingEntity: isLoading,
        deleteError: error,
        deleteEntity: del
    };
}
//# sourceMappingURL=useDeleteEntity.js.map